import { FaFacebook, FaInstagram } from "react-icons/fa";

import { Button } from "@mui/material";
import { Footer } from "antd/es/layout/layout";
import logo from "../NARKS.png"
import logo2 from "../LRM.png"

const MyFooter = () => {
    return (
        <Footer className="bg-black text-white px-6 py-10 text-sm">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
                {/* Column 1 */}
                <div>
                    <h2 className="text-xl font-semibold mb-2">Reality A&amp;T</h2>
                    <p className="mb-6">Objavte Maďarsko s Reality A&amp;T – kde bývanie má štýl a investícia zmysel.</p>
                    <p className="mb-2 font-medium">Máte záujem o zasielanie ponúk?</p>
                    <input
                        type="email"
                        placeholder="Zaregistrujte svoj email"
                        className="bg-transparent border-b border-gray-400 focus:outline-none py-1 w-full"
                    />
                    <Button className="footer-button mt-5" style={{ marginTop: '1rem', borderRadius: '0.25rem', fontWeight: 'bold' }}>ODOSLAŤ</Button>
                </div>

                {/* Column 2 */}
                <div>
                    <h3 className="text-lg font-semibold mb-4">Ponuka</h3>
                    <ul className="space-y-2">
                        <li>Rodinné domy</li>
                        <li>Byty na predaj</li>
                        <li>Chaty a pozemky</li>
                        <li>Novinky v ponuke</li>
                        <li>Kontakt</li>
                    </ul>
                </div>

                {/* Column 3 */}
                <div>
                    <h3 className="text-lg font-semibold mb-4">Reality A&amp;T Trade, s.r.o.</h3>
                    <p className="mb-1">Hviezdoslavova 2</p>
                    <p className="mb-1">045 01 Moldava nad Bodvou</p>
                    <p className="mb-1">reality.zolka9@gmail.com</p>
                    <p className="mb-4">+421 905 738 632</p>
                    <div className="flex items-center gap-4 mb-4">
                        {/* Replace with real icons if needed */}
                        <span className="text-lg"><FaFacebook /></span>
                        <span className="text-lg"><FaInstagram /></span>
                    </div>
                    <div className="flex gap-4">
                        <img src={logo} alt="ARM badge" className="h-20" />
                        <img src={logo2} alt="LRM badge" className="h-20" />
                    </div>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="border-t border-gray-700 mt-10 pt-4 text-center md:text-left text-gray-400 text-xs flex flex-col md:flex-row justify-between items-center">
                <p>© 2025 Reality A&amp;T. All rights reserved.</p>
                <div className="flex gap-4 mt-2 md:mt-0">
                    <a href="#podmienky" className="hover:underline">Obchodné podmienky</a>
                    <a href="#cookies" className="hover:underline">Cookies</a>
                </div>
            </div>
        </Footer>

    )
}

export default MyFooter;